import { TYPES } from '../../flattenTree/utils/consts';
import { ActionsDispatcher } from 'simple-action-dispatcher';
import { getObjectByPath, hasMatchUrlFormatAndKey } from '../utils';
import {
  findInMessagesByUrlFormat,
  findInOperationsByUrlFormat,
  findInRelatedGuidesByUrlFormat,
  findInPropertiesByUrlFormat,
  findInEventsByUrlFormat,
  findInClientEventsByUrlFormat,
} from '../../treeVisitors/helpers';
import { pathToTreeKeys } from '../deleteMembers';

const addSortOrderToTreeNodes = (node, sortOrder, lastKey) => {
  hasMatchUrlFormatAndKey(node, lastKey) && (node.data.sortOrder = sortOrder);
};

const addSortOrderToTreeNodeOperation = (node, sortOrder, memberKey) => {
  const operation = findInOperationsByUrlFormat(node, memberKey);
  operation && (operation.sortOrder = sortOrder);
};

const addSortOrderToTreeNodeRelatedGuides = (node, sortOrder, memberKey) => {
  const guide = findInRelatedGuidesByUrlFormat(node, memberKey);
  guide && (guide.sortOrder = sortOrder);
};

const addSortOrderToTreeNodeClientEvents = (node, sortOrder, memberKey) => {
  const clientEvent = findInClientEventsByUrlFormat(node, memberKey);
  clientEvent && (clientEvent.sortOrder = sortOrder);
};

const addSortOrderToTreeNodeProperties = (node, sortOrder, memberKey) => {
  const guide = findInPropertiesByUrlFormat(node, memberKey);
  guide && (guide.sortOrder = sortOrder);
};

const addSortOrderToTreeNodeMessage = (node, sortOrder, memberKey) => {
  const msg = findInMessagesByUrlFormat(node, memberKey);
  msg && (msg.sortOrder = sortOrder);
};
const addSortOrderToTreeNodeEvents = (node, sortOrder, memberKey) => {
  const msg = findInEventsByUrlFormat(node, memberKey);
  msg && (msg.sortOrder = sortOrder);
};

const initDispatcher = () => {
  const dispatcher = new ActionsDispatcher();
  dispatcher.setDefaultAction(() => {});
  return dispatcher
    .register(TYPES.SECTION, addSortOrderToTreeNodes)
    .register(TYPES.OPERATION, addSortOrderToTreeNodeOperation)
    .register(TYPES.PROPERTY, addSortOrderToTreeNodeProperties)
    .register(TYPES.MD, addSortOrderToTreeNodeRelatedGuides)
    .register(TYPES.MAIN_ENTITY, addSortOrderToTreeNodeMessage)
    .register(TYPES.CLIENT_EVENT, addSortOrderToTreeNodeClientEvents)
    .register(TYPES.CATEGORY, TYPES.SECTION)
    .register(TYPES.TAG, TYPES.SECTION)
    .register(TYPES.EVENT, addSortOrderToTreeNodeEvents)
    .register(TYPES.WEBHOOK, TYPES.EVENT)
    .register(TYPES.TAG, TYPES.SECTION);
};

export const addSortOrderProperty = (docsTree, { type, path, sortOrder }) => {
  const lastKey = path.split('.').pop();
  const dispatcher = initDispatcher();
  const node = getObjectByPath(docsTree, pathToTreeKeys(path));
  dispatcher.dispatch(type, node, sortOrder, lastKey);
};
